import * as React from 'react'
import { OnboardingComponentProps } from '../../molecules/workflow-components'
import { Text, Stack } from '@doordash/design-language'

export const FormPreviewComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ data_map, value }) => {
    return (
      <React.Fragment>
        {data_map.map(d => {
          if (!value[d.name]) {
            return null
          }
          return (
            <Stack size={Stack.Sizes.Small}>
              <Text styles={Text.Styles.Body2Emphasis}>{d.value}</Text>
              <Text styles={Text.Styles.Body2}>{value[d.name]}</Text>
            </Stack>
          )
        })}
      </React.Fragment>
    )
  }
)
